import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PipesModule } from 'src/app/core/pipes/pipes.module';
import { UserNotificationsModule } from 'src/app/shared/user-notifications/user-notifications.module';
import { BrowserRefreshMessageModule } from '../browser-refresh-message/browser-refresh-message.module';
import { HeaderComponent } from './components/header/header.component';
import { AssessmentsSyncMessageComponent } from './components/assessments-sync-message/assessments-sync-message.component';
import { UserHeaderComponent } from './components/user-header/user-header.component';

@NgModule({
  declarations: [HeaderComponent, AssessmentsSyncMessageComponent, UserHeaderComponent],
  imports: [
    CommonModule,
    PipesModule,
    BrowserRefreshMessageModule,
    UserNotificationsModule
  ],
  exports: [HeaderComponent, AssessmentsSyncMessageComponent, UserHeaderComponent],
  entryComponents: [HeaderComponent, AssessmentsSyncMessageComponent, UserHeaderComponent]
})
export class HeaderModule { }
